export enum ExperimentTableCellType {
  UserInfo = `userInfo`,
  Text = `text`,
  Status = `status`,
  Results = `results`,
  FormattedDate = `formattedDate`,
}
